// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"m-","cardContent":"m_","editButton":"na","innerHeading":"nb","header":"nc","subHeader":"nd"};